import type { NewsItem } from "@/types/content";

export const news: NewsItem[] = [
  {
    id: "xingchen-zhixia-dingdang",
    title: "《星辰之下》定档暑期，科幻巨制未映先热",
    summary:
      "备受期待的科幻电影《星辰之下》正式宣布定档，超前的宇宙观设定与顶级视效引发广泛讨论，预售票房已突破预期。",
    content: [
      "由陆沉舟执导的科幻电影《星辰之下》日前正式官宣定档，影片以天体物理学家探寻深空信号为主线，构建了一个宏大而细腻的宇宙图景。",
      "片方发布的首支预告中，荒原、观测站与璀璨星河交替出现，配合低沉而富有张力的配乐，让不少观众直呼『坐不住了』。",
      "业内分析认为，该片在视觉呈现与情感内核上的双重打磨，有望成为本年度科幻题材的一匹黑马。截至目前，影片预售票房已突破同期同类型影片的纪录。",
      "《星辰之下》将于近期登陆全国院线，届时观众可在大银幕上感受这场穿越星空的旅程。",
    ],
    author: "影视观察员",
    date: "2026-10-12",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20wide%20illustration%20of%20a%20glowing%20observatory%20under%20a%20vast%20starry%20night%20sky%20with%20soft%20nebula%2C%20deep%20navy%20and%20amber%20tones%2C%20editorial%20news%20banner%20style%2C%20atmospheric%20lighting%2C%20no%20text&width=800&height=450&seq=nw-xingchen-01&orientation=landscape",
    category: "电影资讯",
    relatedMovieIds: ["xingchen-zhixia", "shenhai-huisheng"],
  },
  {
    id: "changye-jiangming-koubei",
    title: "年度剧王《长夜将明》收官，口碑一路走高",
    summary:
      "年代剧《长夜将明》迎来大结局，凭借扎实的剧本与细腻的表演收获高分评价，成为今年讨论度最高的剧集之一。",
    content: [
      "《长夜将明》自开播以来便以稳健的叙事节奏与考究的年代质感赢得观众青睐，收官当晚多个相关话题登上热搜。",
      "剧集以跨越三十年的家族变迁为背景，通过两代人的命运交织，呈现大时代下普通人的坚守与选择。",
      "不少观众表示，剧中对亲情与家国情怀的刻画真挚动人，多处情节令人潸然泪下。评分平台显示，该剧稳定维持在九分以上的高位。",
      "主创团队透露，未来或将推出围绕同一世界观衍生内容，值得持续关注。",
    ],
    author: "追剧小组",
    date: "2026-10-10",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20wide%20illustration%20of%20a%20nostalgic%20old%20town%20at%20golden%20dawn%20with%20lanterns%20and%20a%20lone%20figure%2C%20warm%20amber%20and%20teal%20palette%2C%20editorial%20news%20banner%20style%2C%20painterly%20texture%2C%20no%20text&width=800&height=450&seq=nw-changye-02&orientation=landscape",
    category: "电视剧动态",
    relatedMovieIds: ["changye-jiangming", "gucheng-jiunmeng"],
  },
  {
    id: "jiye-xingdong-pingfen",
    title: "《极夜行动》开分8.6，谍战题材再出爆款",
    summary:
      "新版谍战剧《极夜行动》首播即收获高分，紧凑的节奏与实力派阵容让这部剧迅速出圈，成为近期口碑黑马。",
    content: [
      "由高群书执导的谍战剧《极夜行动》开播后迅速引发关注，观众普遍认为该剧在节奏把控与悬念设置上表现亮眼。",
      "剧集将故事置于极昼极夜交替的边境小城，阴影与光线形成强烈反差，为主角的潜伏身份增添了层层张力。",
      "多位实力派演员的对手戏被网友称为『教科书级别』，细节处的眼神与停顿都充满信息量。",
      "随着剧情推进，主角能否完成最后的任务成为观众热议的焦点。",
    ],
    author: "剧评人阿舟",
    date: "2026-10-08",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20wide%20illustration%20of%20a%20snowy%20border%20town%20under%20aurora%20night%20sky%20with%20a%20lone%20agent%20silhouette%2C%20cold%20blue%20and%20warm%20amber%20contrast%2C%20editorial%20news%20banner%20style%2C%20no%20text&width=800&height=450&seq=nw-jiye-03&orientation=landscape",
    category: "电视剧动态",
    relatedMovieIds: ["jiye-xingdong", "dushi-mian"],
  },
  {
    id: "haiwai-xinpian-laiixi",
    title: "海外新片接连来袭，进口片市场迎来小高潮",
    summary:
      "多部海外新片宣布引进，涵盖科幻、惊悚与文艺等多个类型，为观众带来更丰富的观影选择。",
    content: [
      "近期多部海外影片陆续官宣引进计划，类型覆盖科幻、深海惊悚与爱情文艺等，满足了不同口味观众的期待。",
      "其中深海题材影片《深海回声》凭借独特的视听设计吸引眼球，深海幽闭空间的压迫感成为影片亮点之一。",
      "此外，法国科幻爱情片《星河旅人》也将在艺术院线进行特别放映，适合偏爱文艺表达的观众。",
      "业内人士表示，进口片的丰富供给有助于进一步激活市场活力。",
    ],
    author: "环球影讯",
    date: "2026-10-06",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20wide%20illustration%20of%20a%20deep%20ocean%20scene%20with%20a%20small%20submarine%20beam%20and%20distant%20planet%20above%20water%2C%20dark%20teal%20and%20cyan%20tones%2C%20editorial%20news%20banner%20style%2C%20no%20text&width=800&height=450&seq=nw-haiwai-04&orientation=landscape",
    category: "电影资讯",
    relatedMovieIds: ["shenhai-huisheng", "xinghe-lvren"],
  },
  {
    id: "jianying-changge-yingping",
    title: "《剑影长歌》影评：水墨江湖里的侠义回归",
    summary:
      "古装武侠片《剑影长歌》以写意的水墨美学和硬桥硬马的动作设计，重新唤起观众对传统武侠的浪漫想象。",
    content: [
      "《剑影长歌》讲述了隐世剑客为道义重入江湖的故事，影片在视觉上大量借鉴水墨山水的留白美学，画面富有诗意。",
      "动作设计摒弃了过度依赖特效的浮夸风格，回归真实招式的力量与节奏，几场对决被观众反复回味。",
      "有影评人认为，影片真正打动人的并非打斗，而是主角在恩怨与道义之间的艰难抉择。",
      "对于喜爱传统武侠的观众而言，《剑影长歌》无疑是一份诚意之作。",
    ],
    author: "影评人南风",
    date: "2026-10-04",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20wide%20illustration%20of%20a%20lone%20swordsman%20on%20a%20misty%20mountain%20peak%20with%20flowing%20robes%2C%20ink-wash%20martial%20arts%20aesthetic%2C%20muted%20blue%20and%20warm%20gold%20tones%2C%20editorial%20banner%20style%2C%20no%20text&width=800&height=450&seq=nw-jianying-05&orientation=landscape",
    category: "影评推荐",
    relatedMovieIds: ["jianying-changge", "huangyuan-qishi"],
  },
  {
    id: "shanhai-zhijian-wenqing",
    title: "治愈系剧集《山与海之间》为何让人上头",
    summary:
      "没有强冲突、没有狗血反转，慢节奏的《山与海之间》却凭借真诚的情感打动了无数观众，成为治愈剧代表。",
    content: [
      "《山与海之间》讲述年轻人返乡经营海边民宿的故事，剧中没有激烈的戏剧冲突，取而代之的是生活的真实质感。",
      "每一集都以一位旅人的故事为线索，民宿成为不同人生交汇的温暖场域。",
      "导演用大量自然的光线与海景镜头，营造出松弛而治愈的氛围，被观众形容为『一剂情绪良药』。",
      "在快节奏的都市生活中，这样一部慢下来的作品显得尤为珍贵。",
    ],
    author: "剧评人阿舟",
    date: "2026-10-02",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20wide%20illustration%20of%20a%20cozy%20seaside%20guesthouse%20on%20a%20rocky%20coast%20with%20distant%20mountains%20and%20gentle%20waves%2C%20soft%20blue%20and%20warm%20cream%20tones%2C%20calm%20healing%20atmosphere%2C%20no%20text&width=800&height=450&seq=nw-shanhai-06&orientation=landscape",
    category: "电视剧动态",
    relatedMovieIds: ["shanhai-zhijian", "chunri-youju"],
  },
  {
    id: "dushi-mian-jiexi",
    title: "《都市迷案》追更解析：细节里藏着多少伏笔",
    summary:
      "刑侦剧《都市迷案》以缜密的案件设计收获好评，观众在追更之余热衷于挖掘剧中的隐藏细节与伏笔。",
    content: [
      "《都市迷案》采用单元案件与主线交织的结构，每个案件看似独立，却都指向一个更深层的真相。",
      "剧组在道具与场景上埋下大量细节线索，随着主线推进，早前的画面被反复『回收』，带来强烈的解谜快感。",
      "刑警队长与法医的搭档关系也是剧集的一大看点，专业推理与人物默契相得益彰。",
      "对悬疑爱好者来说，这部剧的复盘乐趣丝毫不亚于观剧本身。",
    ],
    author: "悬疑小组",
    date: "2026-09-30",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20wide%20illustration%20of%20a%20neon-lit%20modern%20city%20at%20night%20with%20rain-slicked%20streets%20and%20a%20detective%20silhouette%2C%20deep%20blue%20and%20orange%20neon%20tones%2C%20tense%20crime%20mood%2C%20no%20text&width=800&height=450&seq=nw-dushi-07&orientation=landscape",
    category: "电视剧动态",
    relatedMovieIds: ["dushi-mian", "miwu-zhuixiong"],
  },
  {
    id: "chunri-youju-zaiyin",
    title: "《春日邮局》再映引共鸣，书信里的温柔叙事",
    summary:
      "文艺电影《春日邮局》重温放映后再度引发讨论，用书信串联起的温柔故事让不少观众感慨『慢下来的美好』。",
    content: [
      "《春日邮局》以濒临关闭的乡村邮局为舞台，用一封封书信串联起陌生人的心事与相遇。",
      "影片节奏舒缓，樱花与信纸的意象反复出现，营造出清新而动人的氛围。",
      "有观众表示，在即时通讯的时代，这部电影让人重新想起等待与书写的温度。",
      "此次重温放映也带动了相关话题的回潮，成为文艺片受众的心头好。",
    ],
    author: "文艺放映室",
    date: "2026-09-28",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20wide%20illustration%20of%20a%20small%20rural%20post%20office%20among%20blooming%20cherry%20blossom%20trees%20in%20soft%20pink%20daylight%2C%20gentle%20pastel%20tones%2C%20tender%20healing%20mood%2C%20no%20text&width=800&height=450&seq=nw-chunri-08&orientation=landscape",
    category: "影评推荐",
    relatedMovieIds: ["chunri-youju", "shanhai-zhijian"],
  },
  {
    id: "gucheng-jiunmeng-huaxu",
    title: "《故城旧梦》续作传闻四起，主创回应引期待",
    summary:
      "年代爱情剧《故城旧梦》完结后热度不减，关于续作的传闻不断，主创在采访中的回应更是点燃了剧迷热情。",
    content: [
      "《故城旧梦》以民国江南小城为背景，讲述一段跨阶级的爱情故事，收官后仍长期占据讨论热榜。",
      "近日有关续作的消息在网络流传，主创团队在采访中表示『一切都在计划之中』，但未透露具体细节。",
      "不少剧迷期待能够看到原班人马回归，延续这段故城里的旧梦。",
      "无论续作与否，这部作品已然成为年代爱情题材中的一份独特记忆。",
    ],
    author: "追剧小组",
    date: "2026-09-25",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20wide%20illustration%20of%20a%20romantic%20old%20southern%20town%20canal%20with%20lanterns%20reflecting%20on%20water%20at%20dusk%2C%20warm%20amber%20and%20rose%20tones%2C%20nostalgic%20period%20mood%2C%20no%20text&width=800&height=450&seq=nw-gucheng-09&orientation=landscape",
    category: "电视剧动态",
    relatedMovieIds: ["gucheng-jiunmeng", "changye-jiangming"],
  },
  {
    id: "xinghe-lvren-yishu",
    title: "《星河旅人》艺术院线特别放映，科幻浪漫再定义",
    summary:
      "法国科幻爱情片《星河旅人》开启艺术院线特别放映，用光年尺度的通信重新诠释了思念与距离。",
    content: [
      "《星河旅人》讲述星际航线旅人与地球女孩通过延迟信号相爱的故事，将科幻设定与细腻情感巧妙融合。",
      "影片的视觉设计极具诗意，紫色星云与蓝色星球构成梦幻的宇宙图景。",
      "艺术院线的特别放映吸引了大量文艺影迷，映后交流中不少观众分享了自己对『距离』的理解。",
      "这或许不是一部传统意义上的科幻大片，却是一部关于爱与时间的浪漫寓言。",
    ],
    author: "环球影讯",
    date: "2026-09-22",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20wide%20illustration%20of%20a%20spacecraft%20drifting%20near%20a%20glowing%20purple%20nebula%20with%20a%20distant%20blue%20planet%2C%20poetic%20sci-fi%20romance%20mood%2C%20soft%20violet%20and%20teal%20tones%2C%20no%20text&width=800&height=450&seq=nw-xinghe-10&orientation=landscape",
    category: "电影资讯",
    relatedMovieIds: ["xinghe-lvren", "xingchen-zhixia"],
  },
];